export default __webpack_public_path__ + "static/media/RegistryOff.cceb179b.svg";